"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.boxShadow = void 0;
var _styledComponents = require("styled-components");
// TODO: создать систему теней
var boxShadow = exports.boxShadow = '0 10px 15px 0 rgba(216, 214, 204, 0.9), 0 1px 2px 0 rgba(210, 208, 197, 0.9)';
var _default = exports["default"] = {
  elements: {
    tooltip: {
      primary: '#ffffff',
      warning: '#f8e71c',
      error: '#f9eaec'
    },
    button: {
      primary: (0, _styledComponents.css)(["--background-color:var(--secondary);background-color:var(--background-color);border:0;border-radius:var(--border-radius);color:var(--secondary-color);", " ", ""], function (_ref) {
        var disabled = _ref.disabled;
        return !disabled && (0, _styledComponents.css)([":hover{background:linear-gradient( 0deg,rgba(0,0,0,var(--hover-alpha)) 0%,rgba(0,0,0,var(--hover-alpha)) 100% ),var(--background-color);}:active{background:linear-gradient( 0deg,rgba(0,0,0,var(--pressed-alpha)) 0%,rgba(0,0,0,var(--pressed-alpha)) 100% ),var(--background-color);}"]);
      }, function (_ref2) {
        var disabled = _ref2.disabled;
        return disabled && (0, _styledComponents.css)(["opacity:var(--disabled-opacity);"]);
      })
    }
  },
  colors: {
    black: '#000000',
    blackBase: '#17181a',
    purpleBrown: '#160c0d',
    blackLight: '#4d4d4d',
    lightGrey: '#d6d5c9',
    paleGrey: '#ece8f1',
    butteryWhite: '#fffbe8',
    concrete: '#f2f2f2',
    greyLight: '#919499',
    frenchGray: '#c2c5cc',
    whiteLight: '#e6e9ee',
    brightBlue: '#005eff',
    blue: '#007aff',
    brightBlueAlpha: 'rgba(0, 94, 255, 0.6)',
    laPalma: '#15b323',
    lightGreen: '#6ab517',
    brightTeal: '#00ffc1',
    pinkBase: '#f9eaec',
    yellowBase: '#f8e71c',
    gold: '#ffd600',
    beige: '#f3f2e8',
    white: '#ffffff',
    greyishBrown: '#574337',
    veryLightPink: '#f5f3f2',
    nomad: '#b8b6a6',
    monza: '#d0021b',
    solitude: '#e6f2ff',
    moonMist: '#d6d5c3',
    snowFlurry: '#e5ffcb',
    greenApple: '#3cbf1f',
    veryLightGreen: '#e4ffc9',
    darkishPurple: '#4b137b',
    coolGrey: '#919499',
    cloudyBlue: '#c2c5cc',
    topey: '#f1f7d2',
    yellowLight: '#fffbe5',
    greySoft: '#565a5f'
  },
  typography: {
    headline1: (0, _styledComponents.css)(["font-size:28px;font-weight:500;"]),
    headline2: (0, _styledComponents.css)(["font-size:22px;font-weight:500;"]),
    headline3: (0, _styledComponents.css)(["font-size:18px;font-weight:500;"]),
    headline4: (0, _styledComponents.css)(["font-size:14px;font-weight:500;"]),
    headline5: (0, _styledComponents.css)(["font-size:14px;font-weight:500;"]),
    headline6: (0, _styledComponents.css)(["font-size:12px;font-weight:500;"]),
    headline7: (0, _styledComponents.css)(["font-size:12px;"]),
    text1: (0, _styledComponents.css)(["font-size:14px;"]),
    text2: (0, _styledComponents.css)(["font-size:12px;letter-spacing:0.9px;"]),
    text3: (0, _styledComponents.css)(["font-size:12px;"]),
    mobileHeadline1: (0, _styledComponents.css)(["font-size:15px;font-weight:500;"]),
    mobileHeadline2: (0, _styledComponents.css)(["font-size:13px;font-weight:500;"]),
    mobileHeadline3: (0, _styledComponents.css)(["font-size:11px;font-weight:500;"]),
    mobileHeadline4: (0, _styledComponents.css)(["font-size:11px;font-weight:500;"]),
    t1s: (0, _styledComponents.css)(["font-size:13px;"]),
    t2s: (0, _styledComponents.css)(["font-size:11px;"])
  },
  shape: {
    borderRadius: '4px',
    borderRadiusBig: '6px'
  },
  gradient: {
    darkBlueToLight: function darkBlueToLight() {
      var angle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return (0, _styledComponents.css)(["background-image:linear-gradient(", "deg,#5ac9f5,#1f80f1);"], angle);
    }
  }
};